import { config, ELocale } from 'affiny-core/env';
import wretch from 'wretch';
import { errorMiddleware } from '../middlewares/errorMiddleware';

export const getAffinyBaseEndPoint = () =>
  wretch(
    config.env.meeticApi.baseApiHostname + config.env.meeticApi.baseApiPath
  )
    .headers({
      'X-Client': config.env.meeticApi.xClientId,
      'accept-language': ELocale[config.env.locale],
    })
    .content('application/json')
    .middlewares([errorMiddleware()]);
